import { render, staticRenderFns } from "./XvOrderDone.vue?vue&type=template&id=9e06883a&"
import script from "./XvOrderDone.vue?vue&type=script&lang=ts&"
export * from "./XvOrderDone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports